/**
 * 成功图标
 */
const SuccessIcon = ({ width = 16, height = 16, color = 'black' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none">
      <path
        d="M14.6648 8.00023C14.6648 11.6821 11.68 14.6669 7.99813 14.6669C4.31623 14.6669 1.33146 11.6821 1.33146 8.00023C1.33146 4.31833 4.31623 1.33357 7.99813 1.33357C11.68 1.33357 14.6648 4.31833 14.6648 8.00023Z"
        stroke="black"
        strokeWidth="1.33333"
        strokeLinejoin="round"
      />
      <path
        d="M12.0285 6.17219L11.1904 5.33414L7.08251 9.44336L7.08251 10.2814L7.92056 10.2814L12.0285 6.17219Z"
        fill={color}
      />
      <path
        d="M4.83512 7.50637L3.99707 8.34442L5.93507 10.2824L6.77312 10.2824L6.77312 9.44437L4.83512 7.50637Z"
        fill={color}
      />
    </svg>
  )
}

export default SuccessIcon
